<template>
<div class="has-text-centered mtb-3">
  <p class="is-size-4 mb-4">{{ text }}</p>
  <slot />
</div>  
</template>
<script>
export default {
  
  props: {
    text: String,
    required: true
  }

}
</script>